<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1>Telephony Webhooks</h1>
    </div>
  </div>
</div>
<div class="content-container">
  <div class="flex">
    <button
      pButton
      type="button"
      label="Setup"
      class="ui-button ui-button-primary ui-button-success btn-to-right pull-right"
      (click)="setupSubscriptions()"
    ></button>
  </div>
  <p-table [value]="callEventSubscriptions" [loading]="isLoadingSubscriptions">
    <ng-template pTemplate="header">
      <tr>
        <th>URL</th>
        <th>Call States</th>
        <th>Secret</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-itemUntyped>
      <ng-container *ngIf="asCallEventSubscription(itemUntyped) as item">
        <tr>
          <td>
            <span>{{ item.webhook?.hook_url }}</span>
          </td>
          <td>
            <span>{{ item.call_states?.join(', ') }}</span>
          </td>
          <td>
            <span>{{ item.webhook?.signature?.secret }}</span>
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="2">No subscriptions found</td>
      </tr>
    </ng-template>
  </p-table>
</div>
